import React, { useEffect, useState } from "react";
import './HomeAssistantPage.css';
import { useDispatch, useSelector } from "react-redux";
import {
  getHomeAssistantsAsync,
  createHomeAssistantAsync,
  updateHomeAssistantAsync,
  deleteHomeAssistantAsync,
  getLoading,
} from "../../../features/redux/adminSlice";
import SideSlider from "../../ui/SideSlider/SideSlider";
import Confirm from "../../ui/Confirm/Confirm";
import { useForm } from 'react-forms-handler';
import validator from 'validator';
import moment from 'moment';

function HomeAssistantPage({ homeAssistants, offices }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const [filteredHomeAssistants, setFilteredHomeAssistants] = useState(homeAssistants);
  const [openForm, setOpenForm] = useState(false);
  const { form, valid, value, id, url, token, office_id } = useForm({
    id: [''],
    url: ['', (str) => !validator.isEmpty(str)],
    token: ['', (str) => !validator.isEmpty(str)],
    office_id: ['', (str) => !validator.isEmpty(str)],
  });

  const { searchField } = useForm({
    searchField: ['']
  });

  useEffect(() => {
    setFilteredHomeAssistants(homeAssistants.filter(ha => getSearchableText(ha).toLowerCase().includes(searchField.value.toLowerCase())));
  }, [homeAssistants, searchField]);

  useEffect(() => {
    searchField.stateChange.subscribe((currentValue) => {
      setFilteredHomeAssistants(homeAssistants.filter(ha => getSearchableText(ha).toLowerCase().includes(currentValue.toLowerCase())));
    });
  }, [searchField]);

  const getOfficeName = (officeId) => {
    const office = offices.find(o => o.id === officeId);
    return office ? office.name : 'Unknown Office';
  };

  return (
    <div className="home-assistant-dashboard-content">
      <div className="dashboard-header">
        <h1>Admin Dashboard Home Assistants</h1>
        <input style={{ width: '20%' }} type="text" className="form-control" {...searchField.inputProps} placeholder="Search" />
        <button className="btn btn-primary" onClick={() => { setOpenForm(true) }}>Add Home Assistant</button>
      </div>
      <table className="table">
        <thead className="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">URL</th>
            <th scope="col">Office</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredHomeAssistants.map((homeAssistant, index) => (
            <tr key={`homeAssistant-${index}`}>
              <th scope="row">{index + 1}</th>
              <td>{homeAssistant.url}</td>
              <td>{getOfficeName(homeAssistant.office_id)}</td>
              <td>{moment(homeAssistant.createdAt).format("MMM Do YY")}</td>
              <td>
                <i className={`text-danger fa-solid fa-${isLoading.homeAssistants !== homeAssistant.id ? 'trash' : 'circle-notch fa-spin'}`} onClick={() => {
                  Confirm.confirm('Are you sure you want to delete this Home Assistant? This action cannot be undone').then(() => {
                    dispatch(deleteHomeAssistantAsync(homeAssistant.id));
                  }).catch((e) => { console.log(e); });
                }}></i>
                <i style={{ marginLeft: '4px', cursor: 'pointer' }} className={`text-primary fa-solid fa-edit`} onClick={() => {
                  form.clearAllFields();
                  id.value = homeAssistant.id;
                  url.value = homeAssistant.url;
                  token.value = homeAssistant.token;
                  office_id.value = homeAssistant.office_id;
                  setOpenForm(true);
                }}></i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} className={`text-primary fa-solid fa-rectangle-xmark`} onClick={() => {
          setOpenForm(false);
          form.clearAllFields();
        }}></i>
        <form style={{ textAlign: 'left' }}>
          <div className="form-group">
            <label>URL</label>
            <input type="text" {...url.inputProps} className="form-control" placeholder="Enter URL" />
            {url.touched && !url.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Token</label>
            <input type="text" {...token.inputProps} className="form-control" placeholder="Enter Token" />
            {token.touched && !token.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Office</label>
            <select {...office_id.inputProps} className="form-control">
              {offices.map((office) => (
                <option key={office.id} value={office.id}>{office.name}</option>
              ))}
            </select>
            {office_id.touched && !office_id.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <button disabled={!valid || isLoading.homeAssistants} type="submit" className="btn btn-primary" onClick={(e) => {
            if (id.value) {
              dispatch(updateHomeAssistantAsync(value));
            } else {
              dispatch(createHomeAssistantAsync(value));
            }
            setOpenForm(false);
            form.clearAllFields();
            e.preventDefault();
          }}>Submit</button>
        </form>
      </SideSlider>
    </div>
  );
}

function getSearchableText(homeAssistant) {
  return `${homeAssistant.url}${homeAssistant.office_id}${moment(homeAssistant.createdAt).format("MMM Do YY")}`;
}

export default HomeAssistantPage;
